import { Overlay, OverlayRef } from "@angular/cdk/overlay";
import { ComponentPortal } from "@angular/cdk/portal";
import { Injectable } from "@angular/core";

import { ProgressContainerComponent } from "../components/progress-container/progress-container.component";

@Injectable({ providedIn: "root" })
export class GlobalOverlayService {
  private overlayRef: OverlayRef;
  private overlayCounters = 0;

  constructor(private overlay: Overlay) {}

  show() {
    this.overlayCounters++;

    // overlay is already active (we have just incremented the first overlay counter)
    if (this.overlayCounters > 1) {
      return;
    }

    this.overlayRef = this.overlay.create({
      positionStrategy: this.overlay.position().global().centerHorizontally().centerVertically(),
      hasBackdrop: true,
    });

    this.overlayRef.attach(new ComponentPortal(ProgressContainerComponent));
  }

  close() {
    this.overlayCounters--;
    if (this.overlayCounters == 0) {
      /** Dispose instead of Detach called because of issues with not removing overlay
       * spinner after detach on mat-slider dragEnd
       *  */
      this.overlayRef.dispose();
    }
  }
}
